module.exports = __webpack_public_path__ + "img/sliders-vertical.ac39ccdd.svg";